import {GETTING_STARTED_COLLAPSED} from "./constants/ActionConstants";

export interface ActionState {
    gettingStartedCollapsed: boolean;
}

export const ACTION_CONFIG = {
	gettingStartedCollapsed: true
};
